<template>
    <!--卡项管理 - -->
    <div class="card-valid-day-box">
        <el-radio-group v-model="validType" :disabled="disabled">
            <el-radio :label="1">永久有效</el-radio>
            <el-radio :label="2">
                <el-input ref="inputValid" v-model="validData" :disabled="validType === 1 || disabled" class="valid-data" @blur="blurEvent">
                    <span slot="suffix" class="suffix">天</span>
                </el-input>
            </el-radio>
        </el-radio-group>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CardValidDay",
        model: {
            prop: "data",
            event: "dataChange"
        },
        props: {
            data: {
                type: [String, Number],
                default: -1
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            validType: 1,
            validData: "",
        }),
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function () {
                if(this.data == -1){
                    this.validType = 1;
                }else{
                    obj.log("num:" + this.data);
                    let num = parseInt(this.data);
                    this.validType = 2;
                    this.validData = num > 0 ? num : "";
                }
            },
            //赋值数据
            returnData: function () {
                obj.log("type:"+this.validType);
                if(this.validType === 1)
                    this.$emit("dataChange", -1);
                else {
                    if(this.validData.toString().match(/^[0-9-]+$/)) {
                        let day = parseInt(this.validData);
                        if(day > 0)
                            this.$emit("dataChange", day);
                        else
                            this.$emit("dataChange", -2);
                    } else {
                        this.$emit("dataChange", -2);
                    }
                }
            },

            //光标失去焦点
            blurEvent: function () {
                this.returnData();
            },
        },
        watch: {
            validType: function (newData) {
                if(newData === 2){
                    this.$refs.inputValid.focus();
                    this.returnData();
                }else{
                    this.returnData();
                }
            },
            validData: function (newData) {
                this.returnData();
            },
            data: function (d) {
                this.initData();
            }
        }
    }
</script>

<style scoped>
    .suffix{
        line-height: 40px;
    }
    .valid-data{
        width: 100px;
    }
</style>
